const StatusCircleFill = ({
  percentage,
  primaryColor,
  backgroundColor,
}: {
  percentage: number;
  primaryColor: string;
  backgroundColor: string;
}) => {
  const circleStyle = {
    background: `conic-gradient(
              ${primaryColor} ${percentage * 3.6}deg,
              ${backgroundColor} ${percentage * 3.6}deg
          )`,
    minWidth: "20px",
    height: "20px",
    borderRadius: "50%",
    border: `2px solid ${primaryColor}`,
  };

  return <div className="pulse-mr-1" style={circleStyle}></div>;
};

export default StatusCircleFill;
